'use client'

import type { PrefetchMode } from '@pearlconvert/ui/components/link/link.types'

import { createContext, type ReactNode, useContext } from 'react'

const PrefetchModeContext = createContext<PrefetchMode>('off')

export function PrefetchModeProvider({
  mode,
  children,
}: {
  mode: PrefetchMode
  children: ReactNode
}) {
  return (
    <PrefetchModeContext.Provider value={mode}>
      {children}
    </PrefetchModeContext.Provider>
  )
}

export function usePrefetchMode(): PrefetchMode {
  return useContext(PrefetchModeContext)
}
